import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AppThunk } from '../../redux/store';
import { adobeAnalyticsScriptsSelector } from '../../redux/features/analytics';

/**
 * DODASITE-10654_TODO改善_カウ予約文言変更_web AB振分け計測処理
 * @param groupNo - AB振分けグループNo
 * @returns {AppThunk<void>} AB振分けの計測発火
 */
export const measureTopCounselingTodoListTextABAA = (
  groupNo: string
): AppThunk<void> => {
  return (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (groupNo === '2') {
      tlReadyExecute(isAdobeScript, dispatch, 'TODOcounselingchange_test', {});
    } else if (groupNo === '1') {
      tlReadyExecute(
        isAdobeScript,
        dispatch,
        'TODOcounselingchange_original',
        {}
      );
    }
  };
};
